import { MaterialModule } from '../../../../shared/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListLaboratorioLezioneTutoraggioRoutingModule } from './list-laboratori-lezione-tutoraggio-routing.module';
import { SharedComponentsModule } from '../../../../shared/shared-component.module';
import { ListLaboratorioLezioneTutoraggioComponent } from './list-laboratori-lezione-tutoraggio.component';
import { BoxModule } from 'angular-admin-lte';
import { BoxInfoModule as MkBoxInfoModule } from 'angular-admin-lte';
import { AccordionModule as MkAccordionModule } from 'angular-admin-lte';

@NgModule({
  imports: [
    CommonModule,
    ListLaboratorioLezioneTutoraggioRoutingModule,
    MkAccordionModule,
    BoxModule,
    MkBoxInfoModule,
    MaterialModule,
    SharedComponentsModule,
  ],
  declarations: [ListLaboratorioLezioneTutoraggioComponent],
})
export class ListLaboratorioLezioneTutoraggioModule {}
